// Must stay the first import: installs the console gate before any module that
// logs during init (Network, Socket) is evaluated.
import "./Utilis/debug";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import "./i18n";
import App from "./App";
import { ThemeProvider } from "./Hooks/useTheme";
import reportWebVitals from "./reportWebVitals";
import { store, persistor } from "./redux/store";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } },
});

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider>
            <App />
          </ThemeProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </PersistGate>
  </Provider>
);

reportWebVitals();
serviceWorkerRegistration.register();
